// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1PMff","file":"styles_file__176ji"};